var map = {
	"./en.json": [
		1700,
		60
	],
	"./et.json": [
		1701,
		59
	],
	"./fi.json": [
		1702,
		58
	],
	"./lv.json": [
		1703,
		57
	],
	"./pl.json": [
		1704,
		56
	],
	"./ru.json": [
		1705,
		55
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1697;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy ^\.\/.*\.json$
// module id = 1697
// module chunks = 62